import { useGetPointCentralStatus } from '@/api/property-keyless/point-central/get-point-central-status'

import { PointCentralConnectionFormValues, pointCentralDefaultValues } from './point-central.schema'

// Note: the status endpoint only reports connected/disconnected (`{ isConnected }`) — it
// doesn't echo back username/password/haiku (write-only admin credentials), so the form
// never pre-fills them even when Active, same treatment as Accentra/BMX's write-only creds.
export const usePointCentralConnection = (buildingId: number) => {
  const { data, isLoading, isSuccess } = useGetPointCentralStatus({ buildingId })
  const values: PointCentralConnectionFormValues = pointCentralDefaultValues

  return { isConfigured: isSuccess && Boolean(data?.isConnected), isLoading, values }
}
